module.exports = __webpack_public_path__ + "static/media/festival2022logo-tcc.72e8f809.png";